import React, {useEffect, useRef, useState} from 'react';
import Layout from '../../../components/layout/Layout';
import {sendData} from "../../../store/actions";
import {useHistory} from "react-router-dom";
import {useDispatch} from "react-redux";
import useSocket from "../../common/useSocket";
import UInput from "ubs-framework/v2/UInput";
import * as Icon from "ubs-icons"
import AppHeader from "../../common/components/app-header";
import Validator from "simple-react-validator";
import {useForceUpdate} from "ubs-framework/v2/hooks/useForceUpdate";
import Commonrightcircle from "../../../common/component/RightCircle/commonrightcircle";
import {withRouter} from "../../../common/hocs/routing-hoc";
import LayoutV2 from '../../../components/layout-v2';

import { TEST_ID } from "ubs-framework/v2/test-ids/account-testids";

const ForgotWithRecovery = (props) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [errorMsg, setErrorMsg] = useState("");
    const [disabledBtn, setDisabledBtn] = useState(false);
    const [fieldValue, setFieldValue] = useState({
        identifier: '',
        recoveryCode: '',
    })

    const forceUpdate = useForceUpdate();
    const validator = useRef(new Validator({
        element: (message, className) => <div className="u_error_message">{message}</div>,
        autoForceUpdate: {forceUpdate}
    }));

    const inputChange = (e) => {
        let {name, value} = e.target;
        value = value.replace(/^\s+/g, '').trim()
        setFieldValue((val) => {
            return {...val, [name]: value}
        })
    }

    const {on, off, refresh} = useSocket(res => {
        setDisabledBtn(false)
        if (!res.error) {
            switch (res.event) {
                case 'forgotPasswordWithRecoveryCode':
                    dispatch({type: 'SET_FORGOT_RECOVERY_USER', payload: res?.data?.user})
                    if (res?.data?.success) history.push(`/reset-with-recovery`)
                    break;
                default:
                    return true;
            }
        } else {
            setErrorMsg(res?.data?.error)
            setTimeout(() => setErrorMsg(res.data.error), 5000)
        }
    })

    const onSubmit = data => {
        data?.preventDefault();
        if (validator?.current?.allValid()) {
            setDisabledBtn(true)
            let params = {
                identifier: fieldValue?.identifier,
                recoveryCode: fieldValue?.recoveryCode,
            }
            sendData(dispatch, 'forgotPasswordWithRecoveryCode', params);
        } else {
            validator?.current?.showMessages()
        }

    }
    useEffect(() => {
        on()
        return () => off();
    }, [])

    const onKeyUp = e => {
        if (e.key === "Enter") {
            onSubmit(e)
        }
    }

    return (
        <React.Fragment>
            <LayoutV2 module="forgot">
                <div className="u_p-24">
                    <div className="u_text-center u_mb-24">
                        <h3 className="u_title u_text-bold u_mt-16 u_mb-12">Forgot password with recovery code?</h3>
                        <p className="u_small-font">Enter the email address or username linked to your account, along with the recovery code you to reset your password.</p>
                    </div>

                    <UInput
                        className='u_mb-20'
                        label="Email Address / User Name"
                        asterisk
                        hasError={validator?.current?.message("identifier", fieldValue?.identifier, "required")}
                        testId={TEST_ID.FORGET_WITH_RECOVERY.INPUT_WRAPPER}>
                        <input
                            onKeyUp={onKeyUp}
                            type="text"
                            value={fieldValue?.identifier}
                            name="identifier"
                            onChange={inputChange}
                            placeholder=" "
                            data-testid={TEST_ID.FORGET_WITH_RECOVERY.IDENTIFIER_INPUT} />
                    </UInput>
                    
                    <UInput
                        hasError={validator?.current?.message("recoveryCode", fieldValue?.recoveryCode, "required")}
                        className="u_mb-20"
                        label="Recovery Code"
                        asterisk
                        testId={TEST_ID.FORGET_WITH_RECOVERY.INPUT_WRAPPER}>
                        <input
                            onChange={inputChange}
                            value={fieldValue?.recoveryCode}
                            type="text"
                            onKeyUp={onKeyUp}
                            name="recoveryCode"
                            placeholder=" "
                            autoComplete="off"
                            data-testid={TEST_ID.FORGET_WITH_RECOVERY.RECOVERY_CODE_INPUT} />
                    </UInput>

                    {errorMsg?.length !== 0 && <p className="u_error-message u_mb-15">{errorMsg}</p>}
                    <div className="u_block u_relative">
                        <button
                            disabled={disabledBtn}
                            type="button"
                            onClick={onSubmit}
                            className={`u_acc-btn u_w-full u_cp ${disabledBtn && 'u_white'}`}
                            data-testid={TEST_ID.FORGET_WITH_RECOVERY.BUTTON}>Verify
                        </button>
                        {disabledBtn && <div className="u_btn-loader"><Icon.Preloader size={70} /></div>}
                    </div>

                </div>
            </LayoutV2>
        </React.Fragment>
    );
}


export default withRouter(ForgotWithRecovery);